module.exports = __webpack_public_path__ + "img/p3-2-1.f1472af8.png";